import React from 'react';

const WhatIsHector = () => {
  const features = [
    {
      icon: 'fa-chart-pie',
      gradient: 'from-hector-blue to-cyan-400',
      title: 'Unified Dashboards',
      description: 'Consolidating DSP, Sponsored Ads, and AMC data. No spreadsheets needed.'
    },
    {
      icon: 'fa-robot',
      gradient: 'from-hector-purple to-pink-400',
      title: '24/7 Automation',
      description: 'Rule-based automation for bids, budgets, and keywords that works around the clock.'
    },
    {
      icon: 'fa-users-cog',
      gradient: 'from-green-400 to-cyan-400',
      title: 'AMC Audiences',
      description: 'AMC audience creation with clear path-to-conversion insights.'
    },
    {
      icon: 'fa-gift',
      gradient: 'from-yellow-400 to-orange-400',
      title: 'Free DSP Setup',
      description: 'Zero platform fees for the first 3 months. Get started immediately.'
    }
  ];

  return (
    <section id="what-is-hector" className="py-20 bg-gradient-to-br from-hector-light-grey via-white to-hector-light-grey">
      <div className="container mx-auto px-6">
        <div className="text-center max-w-4xl mx-auto mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-hector-black mb-6">
            The Amazon Ads Platform That <br className="block lg:hidden" />
            <span className="bg-gradient-to-r from-hector-blue to-hector-purple bg-clip-text text-transparent">Brands Actually Use</span>
          </h2>
          <p className="text-xl text-hector-dark-grey leading-relaxed">
            Hector AI is a self-serve Amazon DSP & AMC platform for sellers, agencies, and brands who want to maximize ad performance and profits.
          </p>
        </div>
        
        {/* Feature Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {features.map((feature, index) => (
            <div key={index} className="feature-card bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
              <div className={`w-14 h-14 bg-gradient-to-br ${feature.gradient} rounded-xl flex items-center justify-center mb-4`}>
                <i className={`fas ${feature.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-hector-black mb-3">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
        
        {/* Results Banner */}
        <div className="bg-white rounded-2xl p-8 shadow-xl">
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold bg-gradient-to-r from-hector-blue to-hector-purple bg-clip-text text-transparent mb-2">20-40%</div>
              <div className="text-gray-600">Reduction in wasted ad spend</div>
            </div>
            <div>
              <div className="text-4xl font-bold bg-gradient-to-r from-hector-purple to-hector-pink bg-clip-text text-transparent mb-2">48 Hours</div>
              <div className="text-gray-600">To scale profitable campaigns</div>
            </div>
            <div>
              <div className="text-4xl font-bold bg-gradient-to-r from-green-400 to-cyan-400 bg-clip-text text-transparent mb-2">10+ Hours</div>
              <div className="text-gray-600">Saved weekly on ad management</div>
            </div>
          </div>
        </div>
        
        {/* CTA */}
        <div className="text-center mt-12 space-y-4">
      <a 
  href="https://hector.partnerstack.com/" 
  target="_blank" 
  rel="noopener noreferrer"
>
  <button 
    className="cta-button px-10 py-5 rounded-xl font-semibold text-white text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 w-auto inline-block"
    style={{
      background: "linear-gradient(90deg, #CC2EF4 0%, #3E2EF4 100%)"
    }}
  >
    JOIN THE HECTOR AFFILIATE PROGRAM
  </button>
</a>

          <p className="text-sm text-gray-600">
            Apply now. Start referring immediately. Get paid in 30 days.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhatIsHector;
